(() => {
  if (customElements.get('mvp-footer')) return;
  customElements.define('mvp-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.mobile = matchMedia('(max-width: 749px)');
      this.menus = [...this.querySelectorAll('[data-menu]')];
      this.states = new Map();
      this.menus.forEach(menu => {
        this.states.set(menu, menu.dataset.mobileOpen === 'true');
        menu.addEventListener('toggle', () => {
          if (this.mobile.matches) this.states.set(menu, menu.open);
        }, { signal });
      });
      this.sync = () => this.menus.forEach(menu => {
        menu.open = this.mobile.matches ? this.states.get(menu) : true;
        menu.querySelector('summary').tabIndex = this.mobile.matches ? 0 : -1;
      });
      this.mobile.addEventListener('change', this.sync, { signal });
      this.sync();
      this.setAttribute('data-enhanced', '');
      this.querySelector('[data-back-top]')?.addEventListener('click', event => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        const destination = document.querySelector('main h1,main,[role="main"],body');
        if (destination) {
          const temporary = !destination.hasAttribute('tabindex');
          if (temporary) destination.setAttribute('tabindex', '-1');
          destination.focus({ preventScroll: true });
          if (temporary) destination.addEventListener('blur', () => destination.removeAttribute('tabindex'), { once: true });
        }
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const menu = event.target.closest('[data-menu]');
        if (menu && this.contains(menu)) menu.open = true;
      }, { signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
})();
